import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { TravelLiquiditionService } from '../../services/travel-liquidition/travel-liquidition.service';
import { Travel } from 'src/app/models/travel';
import { liquidationUrl, travelCashUrl } from 'src/app/modules/shared/common/api';

@Component({
  selector: 'app-travel-liquidation-approve-list',
  templateUrl: './travel-liquidation-approve-list.component.html',
  styleUrls: ['./travel-liquidation-approve-list.component.scss']
})
export class TravelLiquidationApproveListComponent implements OnInit {

  keyWords = [];
  isNoResult: boolean = false;
  loading:boolean = false;
  isKeyWord:boolean = false;
  keyTable = '';

  totalRec : number;
  page: number = 1;
  perPage: number;

  travel: any;
  dialogConfig:any;
  formGroup: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<TravelLiquidationApproveListComponent>,
    public liquidationService: TravelLiquiditionService
  ) { }

  ngOnInit() {
    var self =  this;
    this.getList();
  }

  getSelect(res){
    this.dialogRef.close(res);
  }

  getList() {
    let param = [];
    let queryString = '';

    param.push('type=for-liquidation');

    if (this.page) {
      param.push('page='+this.page);
    }
  
    if (param.length) {
      queryString = '?' + param.join('&');
    }

    this.loading = true;
    this.isNoResult = false;
    this.liquidationService.url = travelCashUrl+'/lookup'+ queryString;
    this.liquidationService.getFilter().subscribe(res=>{
      if (res.data) {
        this.travel = new Travel(res.data);
      } else {
        this.isNoResult = true;
      }
      this.totalRec = res.total;
      this.perPage = res.per_page;
      this.loading = false;
      if (res.total == 0) {
        this.isNoResult = true;
      }
    });
  }

  closeOnClick() {
    this.dialogRef.close('');
  }

  pageChange(newPage: number) {
    this.page = newPage;
    this.getList();
		return false;
  }

}
